import {  QUERY_GET_ITVS,QUEY_GET_MASTER_COUNT} from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const postItvList = baseThunk("itvList/postItvList", QUERY_GET_ITVS, "GET");
export const postItvCount = baseThunk("itvList/postItvCount",QUEY_GET_MASTER_COUNT,"GET");